import React, { useState, useEffect } from 'react';
import ContatoList from '../components/ContatoList';
import ContatoForm from '../components/ContatoForm';
import ContatoDetails from './ContatoDetails'; 
import ImportContactsModal from '../components/ImportContactsModal'; 
import './Contatos.css';

function Contatos() {
  const [selectedAluno, setSelectedAluno] = useState(null); 
  const [isCreating, setIsCreating] = useState(false); 
  const [isImporting, setIsImporting] = useState(false); 
  const [searchTerm, setSearchTerm] = useState(''); 
  const [tenantId, setTenantId] = useState(null); // Adicionar estado para o tenantId
  const [errorMessage, setErrorMessage] = useState('');

  // Recuperar o tenantId do localStorage (ou outra fonte)
  useEffect(() => {
    const storedTenantId = localStorage.getItem('tenantId');
    if (storedTenantId) {
      setTenantId(storedTenantId);
    } else {
      setErrorMessage('Nenhum Tenant ID encontrado. Faça login novamente.');
    }
  }, []);

  // Verifica se o tenantId foi carregado
  if (!tenantId && !errorMessage) {
    return <div>Carregando...</div>; // Exibir carregando enquanto busca o tenantId
  }

  return (
    <div className="contatos-container">
      <div className="header-container">
        <h1>Gerenciador de Contatos</h1>

        {/* Mensagem de erro caso o tenantId não tenha sido carregado */}
        {errorMessage && <p className="error-message">{errorMessage}</p>}

        {/* Botões para criar ou importar contatos */}
        {!isCreating && !isImporting && (
          <div className="action-buttons">
            <button onClick={() => setIsCreating(true)} className="add-button">
              Adicionar Contato
            </button>
            <button onClick={() => setIsImporting(true)} className="import-button">
              Importar Contatos
            </button>
          </div>
        )}

        {/* Campo de busca - Exibido apenas quando não estiver criando ou importando */}
        {!isCreating && !isImporting && (
          <input
            type="text"
            placeholder="Buscar por nome..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        )}
      </div>

      {/* Formulário de criação de contato */}
      {isCreating && tenantId && (
        <ContatoForm onCancel={() => setIsCreating(false)} tenantId={tenantId} />
      )}

      {/* Lista de contatos */}
      {!isCreating && !isImporting && tenantId && (
        <ContatoList
          onSelect={(aluno) => setSelectedAluno(aluno)}
          searchTerm={searchTerm} // Passar o termo de pesquisa para a lista
          tenantId={tenantId} // Passar o tenantId para a lista de contatos
        />
      )}

      {/* Detalhes do contato selecionado */}
      {selectedAluno && tenantId && (
        <ContatoDetails aluno={selectedAluno} onClose={() => setSelectedAluno(null)} tenantId={tenantId} />
      )}

      {/* Modal para importar contatos */}
      {isImporting && (
        <ImportContactsModal onClose={() => setIsImporting(false)} />
      )}
    </div>
  );
}

export default Contatos;
